import { useEffect } from 'react'

// The compte rendu can be shared from the meeting's menu or from its panel:
// both tell the « Already shared » list to reload
const eventName = 'meeting-summary-shared'

export function notifyMeetingSummaryShared(meetingId: string) {
  window.dispatchEvent(new CustomEvent(eventName, { detail: meetingId }))
}

export function useOnMeetingSummaryShared(
  meetingId: string,
  callback: () => void
) {
  useEffect(() => {
    const handler = (event: Event) => {
      if ((event as CustomEvent<string>).detail === meetingId) callback()
    }
    window.addEventListener(eventName, handler)
    return () => window.removeEventListener(eventName, handler)
  }, [meetingId, callback])
}

// Same download as the org chart export: base64 from the server → file
export function downloadBase64File(file: {
  data: string
  contentType: string
  filename: string
}) {
  const binary = atob(file.data)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  const url = URL.createObjectURL(new Blob([bytes], { type: file.contentType }))
  const a = document.createElement('a')
  a.href = url
  a.download = file.filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
